@if (data().length <= 0) {
  <div class="row no-data-alert">
    <div class="alert alert-info alert-content"><mat-icon>info</mat-icon>There are no trials/non-trials that match the criteria for this invoice.</div>
  </div>
} @else {
  <div class="row">
    <div class="col-sm-3">
      <mat-card class="small-card">
        <mat-card-title>Trials/Non-trials</mat-card-title>
        <div class="trial-select-list">
          <mat-selection-list [multiple]="false">
            @for (Trial of data(); track Trial) {
              <mat-list-item (click)="selectTrial(Trial)" [class.active]="SelectedTrial() === Trial" class="trial-select-item">
                <div style="width: 100%">
                  <div>
                    {{Trial.TrialNumber}}
                    @if (Trial.Status) {
                      ({{Trial.Status}})
                    }
                  </div>
                </div>
              </mat-list-item>
            }
          </mat-selection-list>
        </div>
      </mat-card>
    </div>

    <div class="col-sm-4">
      <mat-card class="small-card">
        <mat-card-title>
          @if (SelectedTrial()?.SourceSystemLink) {
            <a href="{{SelectedTrial()?.SourceSystemLink}}" target="_blank">{{SelectedTrial()?.TrialNumber}}</a>
          }
          @if (!SelectedTrial()?.SourceSystemLink) {
            <span>{{SelectedTrial()?.TrialNumber}}</span>
          }
        </mat-card-title>
        <mat-card-subtitle class="trial-title">{{SelectedTrial()?.Title}}</mat-card-subtitle>
        @if (SelectedTrial()) {
          <div class="assoc-detail-wrapper" scrollInsetShadow>
            @if (ShowCurrencyMessage()) {
              <div class="alert alert-info" role="alert">
                This trial/non-trial has a different currency compared to others previously selected.
              </div>
            }
            @if (ShowRestrictionMessage()) {
              <div class="alert alert-info" role="alert">
                This cannot be added to current invoice due to its status.
              </div>
            }
            @for (year of SelectedTrial().BudgetYears; track year) {
              <div>
                <div style="display: flex;">
                  {{year.Year}} -
                  {{GetBudgetYearQuotedAmount(year) | number}} {{SelectedTrial().Currency}} Total Committed
                  ({{GetLeft(year) | number}} {{SelectedTrial().Currency}} remaining)
                </div>
                @for (objective of year.Objectives; track objective) {
                  <div style="margin-left: 20px; padding-left: 5px; border-left: 1px solid #888;">
                    <div style="margin-top: 3px; margin-bottom: 0;">
                      {{objective.ObjectiveName}} ({{objective.QuotedAmount | number}} Total Committed)
                      <button mat-icon-button [style.visibility]="canAdd(objective) ? null : 'hidden'" (click)="AddInvoice(objective, SelectedTrial().Currency)" [disabled]="isDisabled() || isAssocDisabled()"><mat-icon>playlist_add</mat-icon></button>
                    </div>
                    <div style="margin-left: 25px; font-size: 130%;">
                      @for (invoice of objective.Invoices; track invoice) {
                        <div>
                          <comma-separated-input [(amount)]="invoice.Amount"
                            [label]="invoice.Name"
                            [controlName]="year.Year + objective.ObjectiveName + invoice.Name"
                            [isDisabled]="!invoice.Editable || isDisabled() || isAssocDisabled()"
                            (amountChange)="RefreshSummary()"
                            [deletable]="invoice.Editable"
                            (deleteInstance)="RemoveInvoice(objective, invoice)"
                          [isDeleteDisabled]="isDisabled() || isAssocDisabled()"></comma-separated-input>
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </mat-card>
    </div>

    <div class="col-sm-5">
      <mat-card class="small-card">
        <mat-card-title>Invoice Summary</mat-card-title>
        <mat-card-subtitle>This invoice</mat-card-subtitle>
        <mat-card-content>
          <table mat-table [dataSource]="Summary()" multiTemplateDataRows class="mat-mdc-table-small">
            <ng-container matColumnDef="trial">
              <th mat-header-cell *matHeaderCellDef>Trial</th>
              <td mat-cell *matCellDef="let row">
                @if (row.Summary == 'Trial') {
                  {{row.TrialNumber}}
                }
                @if (row.Summary == 'Year') {
                  <span style="padding-left: 25px;">{{row.Year}}</span>
                }
                @if (row.Summary == 'None') {
                  <span style="padding-left: 50px;">{{row.ObjectiveName}}</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="year">
              <th mat-header-cell *matHeaderCellDef>Year</th>
              <td mat-cell *matCellDef="let row">
                @if (row.Summary == 'Year') {
                  {{row.Year}}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="objective">
              <th mat-header-cell *matHeaderCellDef>Objective</th>
              <td mat-cell *matCellDef="let row">
                @if (row.Summary == 'None') {
                  {{row.ObjectiveName}}
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="committed">
              <th mat-header-cell style="text-align: right" *matHeaderCellDef>Committed</th>
              <td mat-cell style="text-align: right" *matCellDef="let row">{{row.Committed | number}}</td>
            </ng-container>
            <ng-container matColumnDef="invoiced">
              <th mat-header-cell style="text-align: right" *matHeaderCellDef>Invoiced</th>
              <td mat-cell style="text-align: right" *matCellDef="let row">{{row.Invoiced | number}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="COLUMNS"></tr>
            <tr mat-row *matRowDef="let row; columns: COLUMNS" [style.font-weight]="row.IssummaryItem ? '500' : 'initial'"></tr>
          </table>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
}